import React from 'react';

import { OrdCreate, OrdEdit } from '@ragu-components/ord-components';

import { ApConfigurationsForm } from './ApConfigurationsForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { ApConfiguration } from '@ragu-components/ord-types';

const ApConfigurationsList = React.lazy(async () => import('./ApConfigurationsList'));

export const apConfigurationsResource: OrdResourceProps = {
  key: 'ap_configurations',
  name: 'ap_configurations',
  list: <ApConfigurationsList />,
  create: (
    <OrdCreate>
      <ApConfigurationsForm />
    </OrdCreate>
  ),
  edit: (
    <OrdEdit>
      <ApConfigurationsForm />
    </OrdEdit>
  ),
  options: {},
  recordRepresentation: (record: ApConfiguration) => record.name,
};
